import React from 'react';
import { Button, Tooltip, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { HOME } from '../../../../constants/define/translation';

interface CardNameColumnProps {
  name: string;
  title: any;
}

export default React.memo((props: CardNameColumnProps) => {
  const { t } = useTranslation(HOME);
  return (
    <div className="d-flex">
      {props?.title?.isProductErr ? (
        <Tooltip placement="top" title={t('message.productEcomError')}>
          <Button
            style={{ border: 'none', background: 'none' }}
            icon={<WarningOutlined style={{ color: '#EFEA0B', fontSize: '20px' }} />}
          />
        </Tooltip>
      ) : null}

      <Tooltip placement="top" title={props.name}>
        <Typography.Text className="card-name-tiles">{props.name}</Typography.Text>
      </Tooltip>
    </div>
  );
});
